import { requestBlob } from '@/utils/http/requestBlob';
import { loadImage } from '@/utils/image/loadImage';

async function getImageType(imgSrc: string) {
  const blob = await requestBlob(imgSrc);
  return blob.type;
}

export function getImageAndType(imgSrc: string, isCrossOrigin = false) {
  return Promise.all([loadImage(imgSrc, isCrossOrigin), getImageType(imgSrc)] as const);
}
